<template>
    <div>
        <Header :title="title">
            <template slot="right">
                <div class="mybarRight" v-on:click="toSearch">
                    <span class="iconfont icon-sousuo f12 color_999" />
                </div>
            </template>
        </Header>

        <main class="MainCon bottom0 top55" id="MainCon">
            <template v-if="app.template.type === '92fanli'">
                <NTfanliTopFilter :style-name="app.template.style" :tab-index="tabIndex"
                                  v-on:changeTabIndex="typeListTab" />
                <NTfanliTopGoodsList :style-name="app.template.style" :list="goodsData.list"
                                     :is-more="goodsData.isMore" v-on:loadMore="fetchGoodsList"
                                     ref="goodsList" />
            </template>
            <template v-else-if="app.template.type === 'damai'">
                <DamaiTopFilter :style-name="app.template.style" :tab-index="tabIndex"
                                v-on:changeTabIndex="typeListTab" />
                <DamaiTopGoodsList :style-name="app.template.style" :list="goodsData.list"
                                   :is-more="goodsData.isMore" v-on:loadMore="fetchGoodsList"
                                   ref="goodsList" />
            </template>
            <template v-else>
                <IfanliTopFilter :style-name="app.template.style" :tab-index="tabIndex"
                                 v-on:changeTabIndex="typeListTab" />
                <IfanliTopGoodsList :style-name="app.template.style" :list="goodsData.list"
                                    :is-more="goodsData.isMore" v-on:loadMore="fetchGoodsList"
                                    ref="goodsList" />
            </template>
        </main>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {appService} from '../services/app';
    import IfanliTopFilter from './ifanli/TopFilter';
    import NTfanliTopFilter from './92fanli/TopFilter';
    import DamaiTopFilter from './damai/TopFilter';
    import IfanliTopGoodsList from './ifanli/TopGoodsList';
    import NTfanliTopGoodsList from './92fanli/TopGoodsList';
    import DamaiTopGoodsList from './damai/TopGoodsList';
    import Header from '../components/Header';
    import {isMobile} from '../libs/utils';

    export default {
        components: {
            IfanliTopFilter,
            IfanliTopGoodsList,
            NTfanliTopFilter,
            NTfanliTopGoodsList,
            DamaiTopFilter,
            DamaiTopGoodsList,
            Header
        },
        data() {
            return {
                title: '品牌清仓',
                goodsData: {
                    status: false,
                    isMore: true,
                    loading: false,
                    list: [],
                    pageNum: 1
                },
                tabIndex: 2,
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin + '/goods/brand';
            }
            this.fetchGoodsList({init: true});
        },
        methods: {
            fetchGoodsList: function ({init = false} = {}) {
                let self = this;

                if (self.goodsData.isMore === true && self.goodsData.loading === false) {
                    self.goodsData.loading = true;
                    appService.fetchBrandGoodsList({
                        pageNum: self.goodsData.pageNum,
                        sort: self.tabIndex
                    }).then((res) => {
                        let {code, data} = res;
                        if (code === 200) {
                            if (data['list'].length > 0) {
                                if (init) {
                                    self.$refs.goodsList.toTop(0);
                                    self.goodsData.list = data['list'];
                                } else {
                                    for (let i = 0; i < data['list'].length; i++) {
                                        self.goodsData.list.push(data['list'][i]);
                                    }
                                }
                                self.goodsData.isMore = true;
                                self.goodsData.pageNum++;
                            } else {
                                self.goodsData.isMore = false;
                            }
                        }
                        self.goodsData.loading = false;
                    });
                }
            },
            typeListTab: function (index) {
                this.tabIndex = index;
                this.fetchGoodsList({init: true});
            },
            toSearch: function () {
                this.$router.push({name: 'search'});
            }
        }
    }
</script>

<style scoped>

</style>
